import React from 'react';
import { LoyaltyTermsFlow } from '@/components/loyalty/loyalty-terms-flow';
import {
  onLoyaltyModalHidden,
  useLoyaltyTermsPrompt,
} from '@/hooks/use-loyalty-terms-prompt';

// Renders the loyalty terms prompt. Accept/Decline submit via
// submitLoyaltyProgramTermsDecision; useLoyaltyTermsPrompt owns when it shows.
export const LoyaltyTermsModalWrapper: React.FC = () => {
  const {
    dismiss,
    enrollmentUUID,
    enrollmentFormConfig,
    isVisible,
    latestAcceptanceDisclaimer,
    latestTermsSummary,
    latestTermsUUID,
    latestTermsUrl,
    programBannerImageUrl,
    programBannerText,
    programEnrollmentCompletionText,
    refetch,
  } = useLoyaltyTermsPrompt();

  if (!isVisible) {
    return null;
  }

  return (
    <LoyaltyTermsFlow
      bannerImageUrl={programBannerImageUrl}
      bannerText={programBannerText}
      completionText={programEnrollmentCompletionText}
      enrollmentFormConfig={enrollmentFormConfig}
      enrollmentUUID={enrollmentUUID}
      onClose={(didResolve) => {
        // Snooze either way, so a dismissal does not re-prompt this launch
        dismiss();

        // Refetch to flip shouldPromptForTerms off
        if (didResolve) {
          refetch();
        }

        onLoyaltyModalHidden();
      }}
      termsAcceptanceDisclaimer={latestAcceptanceDisclaimer}
      termsSummary={latestTermsSummary}
      termsUrl={latestTermsUrl}
      termsUUID={latestTermsUUID}
    />
  );
};
